import I18n from "../../../../commons/I18n/I18n";
import ScreenCard from "../../../../components/screen/ScreenCard";
import { AppIcon } from "../../../../config/Config";
import I18nKeys from "../../../../I18n/I18nKeys";
import { ROUTE_COMPANY_USER_PARKING_AREA_TYPES } from "../../../../routing/Routes";
import ParkingAreaTypeCompanyUserListCard from "./ParkingAreaTypeCompanyUserListCard";

const ParkingAreaTypeCompanyUserListScreen = () => (
  <ScreenCard breadcrumbs={[
    {
      name: I18n.tr(I18nKeys.TIPOS_ZONAS_APARCAMIENTOS),
      url: ROUTE_COMPANY_USER_PARKING_AREA_TYPES,
      icon: AppIcon.PARKING,
    },
  ]}>
    <ParkingAreaTypeCompanyUserListCard/>
  </ScreenCard>
);
  
export default ParkingAreaTypeCompanyUserListScreen;
